// import commonHelper from '@/app/utility/common.helper.utility';
import appStrings from '@/app/utility/string.utility';
import DatePicker from 'vue2-datepicker';
import { required } from 'vuelidate/lib/validators';
import assetEmployeeDetails from "../../locationDash/assetStatus/assetStatusUpdate/assetEmployeeDetails";
export default {
  name: 'updateCalibration',
  components: {
    DatePicker,
    assetEmployeeDetails
  },
props: ['rowData'],
//   watch: {
//     currentPage: function() {
//       this.getWeighingMachineData();
//     },
//     perPage: function() {
//       this.currentPage = 1;
//       this.getWeighingMachineData();
//     }
//   },
  data() {
    return {
      uploadCalibrationModal: false,
      isSuccess: false,
      showAlert: false,
      respMessage: null,
      editMode: false,
      payload: null,
      unsubscribe: null,
      loader: false,
      showValueSetModal: false,
      machineCode: null,
      machineName: null,
      modelNo: null,
      serialNo: null,
      manufacturer: {
        text: null,
        value: null
      },
      locCostCenter: {
        text: null,
        value: null
      },
      calFreq: {
        text: null,
        value: null
      },
      status: {
        text: null,
        value: null
      },
      departUser: {
        text: null,
        value: null
      },
      employee: {
        text: null,
        value: null
      },
      capacity: null,
      accuracyReso: null,
      installDate: null,
      lastCalDate: null,
      nextCalDueDate: null,
      calCerExpiryDate: null,
      noteComments: null,
      showHideEmployeeDetailsModalFlag:false
    };
  },
  validations: {
    manufacturer: {
      text: {
        required
      }
    },
    // locCostCenter: {
    //   text: {
    //     required
    //   }
    // },
    calFreq: {
      text: {
        required
      }
    },
    status: {
      text: {
        required
      }
    },
    departUser: {
      text: {
        required
      }
    },
    // machineCode: { required },
    // machineName: { required },
    modelNo: { required },
    serialNo: { required },
    capacity: { required },
    accuracyReso: { required },
    noteComments: { required },
    installDate: { required },
    employee: {
      text: {
        required
      }
    }
  },
  mounted() {
    if(this.rowData){
      this.machineCode = this.rowData.item_code;
      this.machineName = this.rowData.description;
    }
    this.getAdditionalDataById();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save' && this.editMode) {
          this.addEditAdditionalDetail();
        } else if (actionName === 'update') {
          this.editMode = true;
        }
      }
    });
  },
  methods: {
    getAdditionalDataById(){
      const payload = {
        assetId: this.rowData.asset_id
      }
      this.loader = true;
      this.$store
        .dispatch('weighMachine/getAdditionalDataById', payload)
        .then(resp => {
          this.loader = false;
          if (resp.status === 200) {
            const item = resp.data.data;
            this.calCerExpiryDate  = item.calibration_certificate_expiry_date;
            this.calFreq.value  = item.calibration_frequency;
            this.calFreq.text  = item.cal_ferq_meaning;
            this.capacity  = item.capacity;
            // this.cre  = creation_date
            this.departUser.value  = item.department;
            this.departUser.text  = item.department_meaning;
            this.machineName  = item.description;
            this.installDate  = item.installation_date;
            this.lastCalDate  = item.last_calibration_date;
            // this.  = last_updated_by
            // this.last  = last_updation_date
            this.locCostCenter.text  = item.location;
            this.locCostCenter.value  = item.location_id;
            this.machineCode  = item.machine_code;
            this.manufacturer.value  = item.manufacturer;
            this.manufacturer.text  = item.manufacturer_meaning;
            this.modelNo  = item.model_num;
            this.nextCalDueDate  = item.next_calibration_due_date;
            this.noteComments  = item.notes_comments;
            this.accuracyReso  = item.resolution;
            this.serialNo  = item.serial_num;
            this.status.text  = item.status;
            this.status.value  = item.status;
            this.employee.text = item.manager_email;
            this.employee.value = item.manager_email;
          }
        })
        .catch(() => {
          this.loader = false;
        });
    },
    disabledDates(date) {
      // return commonHelper.disabledDates(date, this.installDate);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return date < today;
    },
    showHideEmployeeDetailsModal(flag,item){
      this.showHideEmployeeDetailsModalFlag=flag
      if(!flag && item){
        this.employee.value= item.employeeMail
        this.employee.text= item.employeeMail
      }
        this.accessButtons = {
          deleteAllow: false,
          downloadAllow: false,
          uploadAllow: false,
          editAllow: false,
          addAllow: false,
          printAllow: false,
          approvalAllow: false
      }
    },
    addEditAdditionalDetail() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const payload = {
          machine_code: this.machineCode,
          description: this.machineName,
          manufacturer: this.manufacturer.value,
          manufacturer_meaning: this.manufacturer.text,
          model_num: this.modelNo,
          serial_num: this.serialNo,
          location: this.locCostCenter.value,
          installation_date: this.installDate,
          capacity: +this.capacity,
          resolution: this.accuracyReso,
          calibration_frequency: this.calFreq.value,
          cal_freq_meaning: this.calFreq.text,
          // last_calibration_date: this.lastCalDate,
          next_calibration_due_date: this.nextCalDueDate,
          status: this.status.value,
          department: this.departUser.value,
          department_meaning: this.departUser.text,
          calibration_certificate_expiry_date: this.calCerExpiryDate,
          notes: this.noteComments,
          asset_id: this.rowData.asset_id,
          manager_email: this.employee.text
        };
        this.loader = true;
        this.$store
          .dispatch('weighMachine/addEditAdditionalDetail', payload)
          .then(response => {
            this.loader = false;
            this.showAlert = true;
            if (response.status === 200) {
              this.editMode = false;
              this.isSuccess = true;
              this.respMessage = response.data.message;
              this.getAdditionalDataById();
            } else {
              this.isSuccess = false;
              this.respMessage = response.response.data.message;
            }
          })
          .catch(() => {
            this.loader = false;
          });
        }
      },
      openValueSetModal(vsetCode) {
          this.vsetCode = vsetCode;
          this.showValueSetModal = true;
          this.setTimeVsetCode = setTimeout(() => {
            const vSetData = {
              valueSetName: vsetCode,
              multiFlag: null
            };
            this.eventBus.$emit('valueSetCode', vSetData);
          }, 0);
        },
        selectedvalueSet(item) {
          if (this.vsetCode === appStrings.VALUESETTYPE.LOCATION) {
            this.locCostCenter = {
              value: item.value_set_dtl_id,
              text: item.value_code
            };
          } else if (this.vsetCode === appStrings.VALUESETTYPE.FA_ASSET_MANUFACTURER) {
            this.manufacturer = {
              text: item.value_code,
              value: item.value_set_dtl_id
            };
          } else if (this.vsetCode === appStrings.VALUESETTYPE.STATUS_VSET) {
            this.status = {
              text: item.value_meaning,
              value: item.value_code
            };
          } else if (this.vsetCode === appStrings.VALUESETTYPE.FA_DEPARTMENT) {
            this.departUser = {
              text: item.value_meaning,
              value: item.value_set_dtl_id
            };
          } else if (this.vsetCode === appStrings.VALUESETTYPE.CALIB_FREQUENCY) {
            this.calFreq = {
              text: item.value_meaning,
              value: item.value_set_dtl_id
            };
          }
        },
        closeValueSetModal() {
          this.showValueSetModal = false;
        },
        clearVsetValues(vsetCode) {
          this.vsetCode = vsetCode;
          if (this.vsetCode === appStrings.VALUESETTYPE.LOCATION) {
            this.locCostCenter = {
              value: null,
              text: null
            };
          } else if (this.vsetCode === appStrings.VALUESETTYPE.FA_ASSET_MANUFACTURER) {
            this.manufacturer = {
              text: null,
              value: null
            };
          }
          else if (this.vsetCode === appStrings.VALUESETTYPE.STATUS_VSET) {
            this.status = {
              text: null,
              value: null
            };
          }
          else if (this.vsetCode === appStrings.VALUESETTYPE.FA_DEPARTMENT) {
            this.departUser = {
              text: null,
              value: null
            };
          } 
          else if (this.vsetCode === appStrings.VALUESETTYPE.CALIB_FREQUENCY) {
            this.calFreq = {
              text: null,
              value: null
            };
          }
        },
  },
  beforeDestroy() {
    clearTimeout(this.setTimeVsetCode);
    this.unsubscribe();
  }
};
